import React from "react";
import Swal from "sweetalert2";

const InstallationPopup = ({ close, requestForInstallApp }) => {
    return (
        <>
            <div className="d-flex jutify-content-center align-items-center gap-5">
                <div>
                    <img src="/app/maskable.png" alt="Game" style={{
                        width: "100px",
                        height: "100px",
                    }} />
                </div>
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column justify-content-start align-items-start">
                        <p className="fw-bold"
                            style={{ color: "black" }}
                        >
                            {`Download the APP`}
                        </p>
                        <p style={{
                            color: "red",
                        }}
                        >
                            {`to grab the millions of red envelopes!`}
                        </p>
                    </div>
                    <div className="d-flex gap-2">
                        <button
                            className={"btn btn-sm transparent-button w-50 text-uppercase border border-secondary"}
                            onClick={() => Swal.close()}
                        >
                            Cancel
                        </button>
                        <button
                            className={"btn btn-sm golden-button w-50 text-uppercase"}
                            onClick={requestForInstallApp}>
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InstallationPopup;